import { NetworkingSection } from '@/features/networking'

/**
 * Ponto de montagem da seção de networking.
 *
 * Fino de propósito: a feature `networking` carrega seu próprio formulário,
 * validação e submissão, porque salva em endpoint diferente do recurso `user`
 * resolvido pelo layout da área.
 */
export const NetworkingPanel = () => <NetworkingSection />
